import { setDoc } from 'firebase/firestore'
import { useCallback } from 'react'
import useStore from '../store/useStore'
import { QuestionnaireInterface } from '../types/FirestoreUser'
import { getEffectiveServices } from '../utils/firebaseServiceContext'
import userDoc from '../utils/userDoc'
import useActiveUid from './useActiveUid'

const DEFAULT_INTERFACE: QuestionnaireInterface = 'new'

export default function useQuestionnaireInterface() {
  const activeUid = useActiveUid()
  const questionnaireInterface = useStore(
    (state) => state.firestoreUser?.questionnaireInterface ?? DEFAULT_INTERFACE,
  )
  const setQuestionnaireInterfaceInStore = useStore(
    (state) => state.setQuestionnaireInterface,
  )

  const setQuestionnaireInterface = useCallback(
    async (nextInterface: QuestionnaireInterface) => {
      if (!activeUid) {
        throw new Error('Cannot save questionnaire interface without an active user.')
      }

      const previousUser = useStore.getState().firestoreUser
      setQuestionnaireInterfaceInStore(nextInterface)

      try {
        await setDoc(
          userDoc(activeUid, getEffectiveServices().firestore),
          { questionnaireInterface: nextInterface },
          { merge: true },
        )
      } catch (error) {
        useStore.setState({ firestoreUser: previousUser })
        throw error
      }
    },
    [activeUid, setQuestionnaireInterfaceInStore],
  )

  return { questionnaireInterface, setQuestionnaireInterface }
}
